<template>
  <Card>
    <template #subtitle>Associated store</template>
    <template #content>
      <div :class="$style.inputWrapper">
        <p>{{ attribute }}</p>
        <Select
          v-model="selectedShop"
          :options="availableShops"
          :show-clear="false"
          option-value="id"
          option-label="name"
          @update:model-value="(value) => setAttributeValue(attribute, value)"
        />
      </div>
    </template>
  </Card>
  <div v-if="hasDistribution" :class="$style.distributionSection">
    <h2>Current distribution</h2>
    <DataTable :value="configurationClass.rules">
      <Column field="segment.name" header="Segment">
        <template #body="slotProps">
          <Chip :class="$style.segmentChip">{{ slotProps.data.segment.name }}</Chip>
        </template>
      </Column>
      <Column field="instances" header="Store">
        <template #body="slotProps">
          <ShopDisplay :shop="getShopName(slotProps.data.instances[0].values[0].value)" />
        </template>
      </Column>
    </DataTable>
  </div>
</template>
<script setup lang="ts">
import { ConfigurationRuleFormPageConfigurationClassFragment } from "@/graphql";
import { Shop } from "@/modules/Store/shop.types";
import Card from "primevue/card";
import Chip from "primevue/chip";
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import Select from "primevue/select";
import { PropType, computed, ref, watch } from "vue";
import ShopDisplay from "./ShopDisplay.vue";

const emits = defineEmits(["attribute-value-changed"]);
const props = defineProps({
  configurationClass: {
    type: Object as PropType<ConfigurationRuleFormPageConfigurationClassFragment>,
    required: true,
  },
  availableShops: {
    type: Array as PropType<Shop[]>,
    required: true,
  },
});

const selectedShop = ref("");
const attribute = computed(() => props.configurationClass.instances[0].values[0].technicalName);
const defaultValue = computed(() => props.configurationClass.instances[0].values[0].defaultValue);
const hasDistribution = computed(() => props.configurationClass.rules.length > 0);
function isUUID(value: string) {
  const regex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  return regex.test(value);
}
watch(
  () => defaultValue,
  () => {
    if (isUUID(defaultValue.value)) {
      selectedShop.value = defaultValue.value;
    } else {
      selectedShop.value = props.availableShops?.find((shop) => shop.isDefault === true)?.id;
    }
  },
  {
    immediate: true,
  }
);

function setAttributeValue(technicalName: string, value: string) {
  emits("attribute-value-changed", { technicalName, value });
}
function getShopName(shopId: string) {
  return props.availableShops.find((shop) => shop.id === shopId);
}
</script>
<style module lang="scss">
.inputWrapper {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}
.distributionSection {
  margin-top: 1rem;
}

.segmentChip {
  padding: 10px;
}
</style>
